
/*
 * Copyright (C) 2015 ICOS Group, Newcastle University.  All rights reserved.
 * Contact:  James Alastair McLaughlin <j.a.mclaughlin@ncl.ac.uk>
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions
 * are met:
 *  
 * 1. Redistributions of source code must retain the above copyright
 *    notice, this list of conditions and the following disclaimer.
 *  
 * 2. Redistributions in binary form must reproduce the above copyright
 *    notice, this list of conditions and the following disclaimer in the
 *    documentation and/or other materials provided with the distribution.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE AUTHOR AND CONTRIBUTORS ``AS IS'' AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED.  IN NO EVENT SHALL THE AUTHOR OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS
 * OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
 * HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF
 * SUCH DAMAGE.
 */

"use strict";

var URI = require('urijs'),
    Identified = require('./Identified'),
	util = require('./util');

/**
 * Class to represent an SBOL2 Attachment reference.
 */
class Attachment extends Identified
{
    constructor(sbolDocument, uri) {
		
        super(sbolDocument, uri);
		
        this._source = URI();
        this._format = URI();
        this._size = -1;
		this._hash = '';
    }
	
    /**
     * Set the source URI for this Attachment.
     * @param {string|URI} [source]
     */
    set source(source) {
        this._source = URI(source);
    }

    /**
     * Retrieve the source URI for this Attachment.
     * @returns {URI} [source]
     */
    get source() {
        return this._source;
    }

    /**
     * Set the format for this Attachment.
     * @param {string|URI} [format]
     */
    set format(format) {
        this._format = URI(format);
    }

    /**
     * Retrieve the format for this Attachment.
     * @returns {URI} [format]
     */
    get format() {
        return this._format;
    }

    /**
     * Set the size for this Attachment.
     * @param {Long} [size]
     */
    set size(size) {
        this._size = size;
    }

    /**
     * Retrieve the size for this Attachment.
     * @returns {Long} [size]
     */
    get size() {
        return this._size;
    }

	/**
     * Set the hash for this Attachment.
     * @param {String} [hash]
     */
    set hash(hash) {
        this._hash = hash;
    }

    /**
     * Retrieve the hash for this Attachment.
     * @returns {String} [hash]
     */
    get hash() {
        return this._hash;
    }
}

module.exports = Attachment;

